var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import request from "superagent";
import { getSessionToken, authReducerActions } from "react-adaptive-auth";
import { createAction, handleActions } from "redux-actions";
import { olUtils } from "react-openlayers";

// ------------------------------------
// Constants
// ------------------------------------
export var SAVING_DIGI_THEME_RECORD = "SAVING_DIGI_THEME_RECORD";
export var LOADING_DIGI_THEME_RECORDS = "LOADING_ DIGI_THEME_RECORDS";
export var SAVE_SUCCESS_DIGI_THEME_RECORD = "SAVE_SUCCESS_DIGI_THEME_RECORD";
export var SAVE_FAILED_DIGI_THEME_RECORD = "SAVE_FAILED_DIGI_THEME_RECORD";
export var READ_FAILED_DIGI_THEME_RECORDS = "READ_FAILED_DIGI_THEME_RECORDS";
export var READ_SUCCESS_DIGI_THEME_RECORDS = "READ_SUCCESS_DIGI_THEME_RECORDS";
export var READ_OBJECT_SUCCESS_DIGI_THEME = "READ_OBJECT_SUCCESS_DIGI_THEME";
export var DELETING_DIGI_THEME_RECORD = "DELETING_DIGI_THEME_RECORD";
export var DELETE_DIGI_THEME_RECORD_SUCCESS = "DELETE_DIGI_THEME_RECORD_SUCCESS";
export var DELETE_DIGI_THEME_RECORD_FAILED = "DELETE_DIGI_THEME_RECORD_FAILED";
export var RESET_DIGI_THEME_REDUCER = "RESET_DIGI_THEME_REDUCER";

// ------------------------------------
// Actions
// ------------------------------------
var saving = createAction(SAVING_DIGI_THEME_RECORD);

var saveFailed = createAction(SAVE_FAILED_DIGI_THEME_RECORD, function (error) {
  return {
    error: error
  };
});

var saveSuccess = createAction(SAVE_SUCCESS_DIGI_THEME_RECORD, function (data) {
  return {
    data: data
  };
});

var loading = createAction(LOADING_DIGI_THEME_RECORDS);

var readSuccess = createAction(READ_SUCCESS_DIGI_THEME_RECORDS, function (records, total) {
  return {
    records: records,
    total: total
  };
});

var readObjectSuccess = createAction(READ_OBJECT_SUCCESS_DIGI_THEME, function (record) {
  return {
    record: record
  };
});

var readFailed = createAction(READ_FAILED_DIGI_THEME_RECORDS, function (error) {
  return {
    error: error
  };
});

var deleting = createAction(DELETING_DIGI_THEME_RECORD);

var deleteSuccess = createAction(DELETE_DIGI_THEME_RECORD_SUCCESS, function (data) {
  return {
    data: data
  };
});

var deleteFailed = createAction(DELETE_DIGI_THEME_RECORD_FAILED, function (data) {
  return {
    data: data
  };
});

var resetDigiTheme = function resetDigiTheme() {
  return { type: RESET_DIGI_THEME_REDUCER };
};
// ------------------------------------
// Action creators
// ------------------------------------
var save = function save(data, srid) {
  return function (dispatch, getState, getReducerState) {
    dispatch(saving());

    request.post(getReducerState().adaptiveUrl + "WebServices/client/DataView.asmx/Save").send({
      data: data,
      theme_uuid: getReducerState().themeUuid
    }).set("X-Adaptive-Srid", srid).set("Accept", "application/json").set("gm_session_id", getSessionToken()).then(function (res) {
      return res.body;
    }).then(function (res) {
      res = res.d;

      if (res.sessionExpired) {
        dispatch(authReducerActions.sessionExpired());
      }

      if (!res.success) {
        dispatch(saveFailed({ code: "SAVE_FAILED", message: res.exception.message }));
        return;
      }

      dispatch(saveSuccess(res.data[0].value));
    }).catch(function (e) {
      dispatch(saveFailed(e || { message: "saveFailed" }));
    });
  };
};

var deleteRecord = function deleteRecord(id) {
  return function (dispatch, getState, getReducerState) {
    dispatch(deleting());

    request.post(getReducerState().adaptiveUrl + "WebServices/client/DataView.asmx/Delete").send({
      id: id,
      theme_uuid: getReducerState().themeUuid
    }).set("Accept", "application/json").set("gm_session_id", getSessionToken()).then(function (res) {
      return res.body;
    }).then(function (res) {
      res = res.d;

      if (res.sessionExpired) {
        dispatch(authReducerActions.sessionExpired());
      }

      if (!res.success) {
        dispatch(deleteFailed({
          code: "DELETE_FAILED",
          message: res.exception.message
        }));
        return;
      }

      dispatch(deleteSuccess());
    }).catch(function (e) {
      dispatch(deleteFailed(e || { message: "deleteFailed" }));
    });
  };
};

var readChildren = function readChildren(columns, filter, fkColumn, fkColumnId, srid, start, limit, extraParams) {
  return function (dispatch, getState, getReducerState) {
    dispatch(loading());

    readAny({
      theme_uuid: getReducerState().themeUuid,
      filter: filter,
      fk_column: fkColumn,
      fk_column_id: fkColumnId,
      columns: columns,
      srid: srid,
      start: start,
      limit: limit,
      extraParams: extraParams
    }, srid, false, dispatch, getReducerState);
  };
};

var readAny = function readAny(data, srid) {
  var readObject = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var dispatch = arguments[3];
  var getReducerState = arguments[4];

  request.post(getReducerState().adaptiveUrl + "WebServices/client/DataView.asmx/ReadAny").send({
    request: data
  }).set("Accept", "application/json").set("gm_session_id", getSessionToken()).set("X-Adaptive-SRID", srid).then(function (res) {
    return res.body;
  }).then(function (res) {
    res = res.d;

    if (res.sessionExpired) {
      dispatch(authReducerActions.sessionExpired());
    }

    if (!res.success) {
      dispatch(readFailed(res.exception.message));
      return;
    }
    if (readObject) {
      if (res.records.length !== 1) {
        dispatch(readFailed({
          code: "NO_RECORD_FOUND",
          message: "Kunne ikke finne record"
        }));
      } else {
        dispatch(readObjectSuccess(res.records[0], res.total));
      }
      return;
    }
    dispatch(readSuccess(res.records, res.total));
  }).catch(function (e) {
    dispatch(readFailed(e || { message: "Kunne ikke lese data" }));
  });
};

var readObject = function readObject(id, columns, srid) {
  var only_owned = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  return function (dispatch, getState, getReducerState) {
    dispatch(loading());

    readAny({
      theme_uuid: getReducerState().themeUuid,
      object_id: id,
      columns: columns,
      only_owned: only_owned
    }, srid, true, dispatch, getReducerState);
  };
};

var readOwned = function readOwned(columns, filter, srid, start, limit, extraParams) {
  return function (dispatch, getState, getReducerState) {
    dispatch(loading());

    readAny({
      theme_uuid: getReducerState().themeUuid,
      filter: filter,
      columns: columns,
      srid: srid,
      start: start,
      limit: limit,
      extraParams: extraParams,
      only_owned: true
    }, srid, false, dispatch, getReducerState);
  };
};

var readFiltered = function readFiltered(columns, filter, srid, start, limit, extraParams) {
  return function (dispatch, getState, getReducerState) {
    dispatch(loading());

    readAny({
      theme_uuid: getReducerState().themeUuid,
      filter: filter,
      columns: columns,
      srid: srid,
      start: start,
      limit: limit,
      extraParams: extraParams
    }, srid, false, dispatch, getReducerState);
  };
};

export var actions = {
  save: save,
  deleteRecord: deleteRecord,
  readFiltered: readFiltered,
  readObject: readObject,
  readOwned: readOwned,
  readChildren: readChildren,
  resetDigiTheme: resetDigiTheme
};

// ------------------------------------
// Reducer
// ------------------------------------
var initialState = {
  loading: false,
  saving: false,
  deleting: false,
  error: undefined,
  records: [],
  record: undefined
};

export default (function (key, adaptiveUrl, themeUuid) {
  var _handleActions;

  return handleActions((_handleActions = {}, _handleActions[key + "@@" + SAVING_DIGI_THEME_RECORD] = function (state, _ref) {
    var payload = _ref.payload;

    return Object.assign({}, state, {
      saving: true,
      error: undefined
    });
  }, _handleActions[key + "@@" + LOADING_DIGI_THEME_RECORDS] = function (state, _ref2) {
    var payload = _ref2.payload;

    return Object.assign({}, state, {
      loading: true,
      error: undefined
    });
  }, _handleActions[key + "@@" + SAVE_SUCCESS_DIGI_THEME_RECORD] = function (state, _ref3) {
    var payload = _ref3.payload;

    if (payload.data.geom_wkt) {
      payload.data.olFeature = olUtils.createFeatureFromWkt(payload.data.geom_wkt, payload.data);
    }
    return Object.assign({}, state, {
      saving: false,
      record: payload.data
    });
  }, _handleActions[key + "@@" + SAVE_FAILED_DIGI_THEME_RECORD] = function (state, _ref4) {
    var payload = _ref4.payload;
    return Object.assign({}, state, {
      saving: false,
      error: payload.error
    });
  }, _handleActions[key + "@@" + READ_FAILED_DIGI_THEME_RECORDS] = function (state, _ref5) {
    var payload = _ref5.payload;
    return Object.assign({}, state, {
      loading: false,
      error: payload.error
    });
  }, _handleActions[key + "@@" + READ_SUCCESS_DIGI_THEME_RECORDS] = function (state, _ref6) {
    var payload = _ref6.payload;
    var records = payload.records,
        total = payload.total;

    if (records.length && records[0].geom_wkt) {
      records.forEach(function (r) {
        r.olFeature = olUtils.createFeatureFromWkt(r.geom_wkt, r);
      });
    }
    return Object.assign({}, state, {
      loading: false,
      records: records,
      total: total
    });
  }, _handleActions[key + "@@" + READ_OBJECT_SUCCESS_DIGI_THEME] = function (state, _ref7) {
    var payload = _ref7.payload;
    var record = payload.record;

    if (record.geom_wkt) {
      record.olFeature = olUtils.createFeatureFromWkt(record.geom_wkt, record);
    }
    return Object.assign({}, state, {
      record: record,
      loading: false
    });
  }, _handleActions[key + "@@" + DELETING_DIGI_THEME_RECORD] = function (state, _ref8) {
    var payload = _ref8.payload;

    return Object.assign({}, state, {
      deleting: true,
      error: undefined
    });
  }, _handleActions[key + "@@" + DELETE_DIGI_THEME_RECORD_SUCCESS] = function (state, _ref9) {
    var payload = _ref9.payload;

    return Object.assign({}, state, {
      deleting: false,
      error: undefined
    });
  }, _handleActions[key + "@@" + DELETE_DIGI_THEME_RECORD_FAILED] = function (state, _ref10) {
    var payload = _ref10.payload;

    return Object.assign({}, state, {
      deleting: false,
      error: payload.error
    });
  }, _handleActions[key + "@@" + RESET_DIGI_THEME_REDUCER] = function (state, _ref11) {
    var payload = _ref11.payload;

    return Object.assign({}, state, initialState);
  }, _handleActions), _extends({}, initialState, { adaptiveUrl: adaptiveUrl, themeUuid: themeUuid }));
});